import React from 'react';
import { BoxHeader, DefaultBox } from '../common/DefaultBox';
import BbitTitleIcon from '../../assets/sidebar/Iconly-Bold-Swap.svg';
import bitcoin from '../../assets/sidebar/bitcoin.svg';
const YourLastDeal = () => {
    const items = [
        {
            id: 1,

            Arz: 'بیت کوین',
            cost: '17.870.000',
            changes: '16:40',
            manfi: false,
        },
        {
            id: 2,

            Arz: ' آتریوم',
            cost: '17.870.000',
            changes: '16:40',
            manfi: false,
        },
        {
            id: 3,

            Arz: 'بیت کوین کش ',
            cost: '17.870.000',
            changes: '16:40',
            manfi: false,
        },
        {
            id: 4,

            Arz: ' تتر',
            cost: '17.870.000',
            changes: '16:40',
            manfi: true,
        },

        {
            id: 5,

            Arz: 'لایت کوین',
            cost: '17.870.000',
            changes: '16:40',
            manfi: true,
        },
        {
            id: 6,

            Arz: ' ریپل',
            cost: '17.870.000',
            changes: '16:40',
            manfi: false,
        },
    ];
    return (
        <DefaultBox className="BBit-default-box your-last-deal-box">
            <BoxHeader className="BBit-default-box-header" title="آخرین معاملات " icon={BbitTitleIcon} />

            <div className="table-head">
                <p className="d-flex title-td">نوع ارز</p>

                <p>قیمت</p>
                <p style={{ marginRight: '8px' }}>زمان</p>
            </div>

            {items.map((i) => (
                <div key={i.id} className="table-body">
                    <p className="d-flex title-td">{i.Arz}</p>

                    <p>{i.cost}</p>
                    <p>{i.changes}</p>
                </div>
            ))}
        </DefaultBox>
    );
};

export default YourLastDeal;
